import React, { useState } from "react";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import ContentManager from "./ContentManager";

const MurUsage = () => {
  const [selectedMateriau, setSelectedMateriau] = useState("");
  const [selectedUsage, setSelectedUsage] = useState("");
  const [otherUsage, setOtherUsage] = useState("");
  const [epaisseur, setEpaisseur] = useState("");
  const [otherTypologie, setOtherTypologie] = useState("");
  const [otherEpaisseur, setOtherEpaisseur] = useState("");
  
  // États pour la gestion dynamique des contenus
  const [sections, setSections] = useState([
    {
      id: 1,
      title: "Type de mur",
      content: [
        {
          id: 1,
          type: "products",
          title: "BRIQUE / PARPAING",
          image: "/assets/images/bureau-d-etude/brique-parpaing.png",
          description: "Matériau traditionnel",
          selected: false
        },
        {
          id: 2,
          type: "products", 
          title: "BÉTON",
          image: "/assets/images/bureau-d-etude/beton.png",
          description: "Matériau moderne",
          selected: false
        },
        {
          id: 3,
          type: "products",
          title: "PIERRE", 
          image: "/assets/images/bureau-d-etude/pierre.png",
          description: "Matériau naturel",
          selected: false
        },
        {
          id: 4,
          type: "products",
          title: "PLAQUE BAC ACIER",
          image: "/assets/images/bureau-d-etude/plaque-bac-acier.png",
          description: "Type Tôle Acier",
          selected: false
        }
      ]
    },
    {
      id: 2,
      title: "Usage du bâtiment",
      content: [
        {
          id: 5,
          type: "choice",
          title: "HABITATION",
          selected: false
        },
        {
          id: 6,
          type: "choice", 
          title: "GARAGE / GRANGE",
          selected: false
        },
        {
          id: 7,
          type: "choice",
          title: "AUTRE",
          selected: false
        }
      ]
    }
  ]);

  const handleMateriauSelect = (materiau) => {
    setSelectedMateriau(materiau);
    // Mettre à jour la sélection dans les sections
    setSections(prev => prev.map(section => {
      if (section.title === "Type de mur") {
        return {
          ...section,
          content: section.content.map(item => ({
            ...item,
            selected: item.title === materiau
          }))
        };
      }
      return section;
    }));
  };

  const handleUsageSelect = (usage) => {
    setSelectedUsage(usage);
    setSections(prev => prev.map(section => {
      if (section.title === "Usage du bâtiment") {
        return {
          ...section,
          content: section.content.map(item => ({
            ...item,
            selected: item.title === usage
          }))
        };
      }
      return section;
    }));
  };

  const handleContentAdd = (sectionId, newContent) => {
    setSections(prev => prev.map(section => {
      if (section.id === sectionId) {
        return {
          ...section,
          content: [...section.content, newContent]
        };
      }
      return section;
    }));
  };

  const handleContentRemove = (sectionId, contentId) => {
    setSections(prev => prev.map(section => {
      if (section.id === sectionId) {
        return {
          ...section,
          content: section.content.filter(item => item.id !== contentId)
        };
      }
      return section;
    }));
  };

  const renderContent = (content) => {
    switch (content.type) {
      case "products":
        return (
          <div className="col-6 col-md-3 mb-4">
            <label>
              <input
                type="radio"
                name="materiau"
                value={content.name || content.title}
                checked={content.selected}
                onChange={() => handleMateriauSelect(content.name || content.title)}
                className="materiau-radio"
              />
              <div className="materiau-wrapper">
                <img
                  src={content.image}
                  alt={content.name || content.title}
                  style={{ maxWidth: "100%" }}
                />
                <div className="rectangle px-4 py-1">
                  <p className="Card-title">{content.name || content.title}</p>
                  {content.description && (
                    <p className="Card-sub-title">{content.description}</p>
                  )}
                </div>
              </div>
            </label>
          </div>
        );

      case "choice":
        return (
          <div className="col-12 col-md-4">
            <label className="label-utility">
              <input
                type="radio"
                name="type_batiment"
                value={content.title}
                checked={content.selected}
                onChange={() => handleUsageSelect(content.title)}
                className="utility-radio"
              />
              <div className="utility mb-3">
                <span>{content.title}</span>
              </div>
            </label>
          </div>
        );

      case "text":
        return (
          <div className="col-12 mb-3">
            <div className="text-content p-3 border rounded">
              <h6>{content.name || content.title}</h6>
              <p>{content.description}</p>
            </div>
          </div>
        );

      case "input":
        return (
          <div className="col-12 mb-3">
            <div className="d-flex flex-column">
              <label htmlFor="" className="label-be">
                {content.label || content.title}
              </label>
              <div className="input-wrapper">
                <input 
                  type="text" 
                  placeholder={content.placeholder}
                />
                {content.suffix && <span className="unit">{content.suffix}</span>}
              </div>
              {content.order && (
                <small className="text-muted">Ordre: {content.order}</small>
              )}
            </div>
          </div>
        );

      case "other_choice":
        return (
          <div className="col-12 mb-3">
            <div className="other-choice-box p-3 border rounded">
              <p className="text-center fw-bold">{content.label || content.title}</p>
              {content.order && (
                <small className="text-muted d-block text-center">Ordre: {content.order}</small>
              )}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div className="">
        {/*section banner*/}
        <section className="be-banner">
          <div className="">
            <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
            <p className="be-centered-p">MUR ET USAGE</p>
          </div>
        </section>
        
        <div className="container">
          {sections.map((section) => (
            <div key={section.id} className="form-container mb-4">
              <div className="form-head d-flex justify-content-between align-items-center">
                <p className="text-center mb-0">{section.title}</p>
                <ContentManager 
                  section={section}
                  onContentAdd={handleContentAdd}
                  onContentRemove={handleContentRemove}
                />
              </div>
              
              <div className="be-form p-3 p-md-5">
                <form action="">
                  <div className="text-center">
                    <div className="row select-elements">
                      {section.content.map((content) => (
                        <div key={content.id} className="position-relative">
                          {renderContent(content)}
                          <button
                            type="button"
                            className="btn btn-danger btn-sm position-absolute"
                            style={{ top: "5px", right: "5px" }}
                            onClick={() => handleContentRemove(section.id, content.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Champs spécifiques pour le type de mur */}
                  {section.title === "Type de mur" && selectedMateriau && (
                    <div className="mt-4">
                      <div className="d-flex flex-column">
                        <label htmlFor="" className="label-be">
                          Quelle épaisseur ?
                        </label>
                        <div className="input-wrapper">
                          <input 
                            type="text" 
                            value={epaisseur}
                            onChange={(e) => setEpaisseur(e.target.value)}
                          />
                          <span className="unit">mm</span>
                        </div>
                      </div>
                      <div className="to-consider">
                        <p>
                          La RE 2020 conseille une isolation minimum de 300mm sous toiture !
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Champs spécifiques pour l'usage */}
                  {section.title === "Usage du bâtiment" && selectedUsage === "AUTRE" && (
                    <div className="" style={{ maxWidth: 450, marginTop: 40 }}>
                      <label className="label-be">Si AUTRE : Quel Usage ?</label>
                      <input 
                        type="text" 
                        value={otherUsage}
                        onChange={(e) => setOtherUsage(e.target.value)}
                      />
                    </div>
                  )}
                </form>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MurUsage;